import React from 'react';
import './Bluecovers.css';
import bulbImg from '../../../imgs/blub-cover.webp'; 

const Bluecovers = () => {
  return (
    <div className="led-card-wrapper">
      <h2>LED Bulb Cover</h2>
      <div className="led-card"data-aos="flip-down" >
        <img src={bulbImg} alt="LED Bulb" className="led-img" />
        <div className="led-details">
          <p><strong>Machine Model:</strong> IBM200-S6.R</p>
          <p><strong>Mold Cavity:</strong> 8</p>
          <p><strong>Production Cycle Time:</strong> 17s</p>
          <p><strong>Weight:</strong> 9.5g (1 Φ60 bulb)</p>
          <p><strong>Material:</strong> PC</p>
        </div>
      </div>
    </div>
  );
};

export default Bluecovers;
